import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import ThemePage from '@totem/components/development/Theme';
import PrivacyPolicy from '@totem/components/mobile/PrivacyPolicy';
import RemoteAccessServicesRoot from '@totem/components/remoteAccessServices/RemoteAccessServicesRoot';
import TenantBase from '@totem/components/TenantBase';
import NotFound from '@totem/components/ui_components/pageExceptions/notFound/NotFound';
import NaSurveyPage from '@totem/components/unauthenticated/surveys/instance/naSurveyPage';
import AutoActions from '@totem/components/unauthenticated/ticketing/details/autoActions';
import NATicketDetailsPage from '@totem/components/unauthenticated/ticketing/details/naTicketPage';
import AuthCallback from '@totem/components/userContext/auth/AuthCallback';
import AuthorizedRoute from '@totem/components/userContext/auth/AuthorizedRoute';
import TenantAuthorizedRoute from '@totem/components/userContext/auth/TenantAuthorizedRoute';
import EmailUnverified from '@totem/components/userContext/login/EmailUnverified';
import EmailVerified from '@totem/components/userContext/login/EmailVerified';
import Login from '@totem/components/userContext/login/Login';
import NoAccess from '@totem/components/userContext/login/NoAccess';
import Unverified from '@totem/components/userContext/login/Unverified';
import Logout from '@totem/components/userContext/logout/logout';
import SwitchOrganization from '@totem/components/userContext/organizationSwitch/loginOrganizationSelector/SwitchOrganization';
import ConfigDump from '@totem/components/utilities/configDump/ConfigDump';
import NotificationContainer from '@totem/components/utilities/notification/NotificationContainer';
import VendorLogoContainer from '@totem/components/vendors/vendorLogos/vendorLogoContainer';
import api from '@totem/utilities/api';
import authUtilities from '@totem/utilities/authUtilities';
import configuration from '@totem/utilities/configuration';
import logger from '@totem/utilities/logger';

import Base from './Base';

const Application = () => {
  const location = useLocation();

  useEffect(() => {
    if (!configuration.isProd) {
      logger.debug('Route change:', location.pathname + location.search);
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    api.setAuthToken();
  }, []);

  let defaultPath = '/dashboard';
  if (
    window.location.hostname.startsWith('d-ras') ||
    window.location.hostname.startsWith('d-passwordreset')
  ) {
    defaultPath = '/remoteAccessServices';
  }
  if (
    window.location.hostname.startsWith('ras') ||
    window.location.hostname.startsWith('passwordreset')
  ) {
    defaultPath = '/remoteAccessServices';
  }

  return (
    <div style={{ height: '100%' }}>
      <NotificationContainer>
        <VendorLogoContainer>
          <Routes>
            <Route path="/" element={<Navigate to={defaultPath} replace />} />
            <Route
              path="/remoteAccessServices"
              element={<RemoteAccessServicesRoot />}
            />
            <Route path="/theme" element={<ThemePage />} />
            <Route path="/survey/:id" element={<NaSurveyPage />} />
            <Route path="/ticket/:id" element={<NATicketDetailsPage />} />
            <Route path="/ticket-action/:id" element={<AutoActions />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/dashboard/*"
              element={
                <AuthorizedRoute
                  component={Base}
                  roleSet={authUtilities.ROLE_SETS.VENDOR}
                />
              }
            />
            <Route
              path="/vendor-dashboard/*"
              element={
                <AuthorizedRoute
                  component={Base} // FROM VENDOR BASE
                  roleSet={authUtilities.ROLE_SETS.VENDOR}
                />
              }
            />
            <Route
              path="/tenant-dashboard/*"
              element={
                <TenantAuthorizedRoute
                  component={TenantBase}
                  roleSet={authUtilities.ROLE_SETS.TENANT}
                />
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/ConfigDump" element={<ConfigDump />} />
            <Route path="/no-access" element={<NoAccess />} />
            <Route
              path="/switch-organization"
              element={
                <AuthorizedRoute
                  component={SwitchOrganization}
                  roleSet={authUtilities.ROLE_SETS.VENDOR}
                />
              }
            />
            <Route path="/verified-email" element={<EmailVerified />} />
            <Route path="/unverified-email" element={<EmailUnverified />} />
            <Route path="/unverified" element={<Unverified />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </VendorLogoContainer>
      </NotificationContainer>
    </div>
  );
};

export default Application;
